'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getJSONHeaders;
function getJSONHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
}
module.exports = exports['default'];